import { useFeatureFlag } from '../../Common/Hooks/useFeatureFlag'
import { USER_TRANSCRIBE_TOGGLE_FEATURE_FLAG } from '../../Common/Constants/FeatureFlags'
import { hasCmeCxTranscribeCapability } from '../../Common/Utils/CmeCapabilityUtils'

/**
 * Whether the user modal may offer the "Transcribe calls" toggle (APD-14072), before the user's licences are
 * considered: the opt-in features.yaml flag is on and the user's CME has CX Transcribe for the TelSys type.
 *
 * The flag is opt-in, so a features.yaml without the key, or one that fails to load, hides the toggle until the
 * backend (APD-14067) stores {@code Scope.CXTranscribeEnabled}.
 *
 * @param cmeCapabilities The CME's {@code Capabilities} bitmask, or null/undefined when unknown.
 * @param telSysType The TelSys type, as a numeric id or name.
 * @param callControlOptions The TelSys {@code CallControlOptions}; only used to detect a Simulator emulating BroadWorks.
 * @returns True when the flag is on and the CME allows CX Transcribe.
 */
export const useIsTranscribeAvailable = (
    cmeCapabilities: Nullable<number>,
    telSysType: Nullable<number | string>,
    callControlOptions?: Nullable<string>
): boolean => {
    const isUserTranscribeToggleEnabled: boolean = useFeatureFlag(USER_TRANSCRIBE_TOGGLE_FEATURE_FLAG, false)

    return (
        isUserTranscribeToggleEnabled &&
        hasCmeCxTranscribeCapability(cmeCapabilities, telSysType, callControlOptions)
    )
}
